export default "__VITE_ASSET__15ceed43__"